/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'm9.7 18.7-1.4-1.4 4.6-4.6c.4-.4.4-1 0-1.4L8.3 6.7l1.4-1.5 6.7 6.8-6.7 6.7Z',
  DEV ? 'ChevronForwardIcon' : '',
  '',
  true,
);
